'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./UserProgress.scss');

var UserProgress = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    type_of_document: state.company.type_of_document
  };
}, {}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(UserProgress, _Component);

  function UserProgress(props) {
    (0, _classCallCheck3.default)(this, UserProgress);
    return (0, _possibleConstructorReturn3.default)(this, (UserProgress.__proto__ || (0, _getPrototypeOf2.default)(UserProgress)).call(this, props));
  }

  (0, _createClass3.default)(UserProgress, [{
    key: 'render',
    value: function render() {
      var designScreen = this.props.designScreen;
      var homeScreen = this.props.homeScreen;
      var firstStyle = homeScreen ? styles.inactivemilestone : designScreen ? styles.activemilestone : styles.inactivemilestone;
      var firstStyleText = homeScreen ? styles.inactivemilestonetext : designScreen ? styles.activemilestonetext : styles.inactivemilestonetext;
      var secondStyle = homeScreen ? styles.inactivemilestone : designScreen ? styles.inactivemilestone : styles.activemilestone;
      var secondStyleText = homeScreen ? styles.inactivemilestonetext : designScreen ? styles.inactivemilestonetext : styles.activemilestonetext;
      return _react2.default.createElement(
        'div',
        { className: styles.timeline },
        _react2.default.createElement(
          'div',
          { className: styles.milestones + ' ' + styles.first },
          _react2.default.createElement(
            'h3',
            { className: styles.actualmilestone + ' ' + firstStyle },
            '1'
          ),
          _react2.default.createElement(
            'h3',
            { className: firstStyleText },
            'Select a Design Template'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.milestones + ' ' + styles.second },
          _react2.default.createElement(
            'h3',
            { className: styles.actualmilestone + ' ' + secondStyle },
            '2'
          ),
          _react2.default.createElement(
            'h3',
            { className: secondStyleText },
            'Select a Job Profile'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.milestones + ' ' + styles.third },
          _react2.default.createElement(
            'h3',
            { className: styles.actualmilestone + ' ' + styles.inactivemilestone },
            '3'
          ),
          _react2.default.createElement(
            'h3',
            { className: styles.inactivemilestonetext },
            this.props.type_of_document == 'Personal Website' ? 'Create & Deploy your ' + this.props.type_of_document : 'Create & Download your ' + this.props.type_of_document
          )
        )
      );
    }
  }]);
  return UserProgress;
}(_react.Component)) || _class);
exports.default = UserProgress;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/UserProgress/UserProgress.js
// module id = 1754
// module chunks = 0